import { render } from "./TeacherDetail.vue?vue&type=template&id=1f1373aa&scoped=true&ts=true"
import script from "./TeacherDetail.vue?vue&type=script&lang=ts"
export * from "./TeacherDetail.vue?vue&type=script&lang=ts"

import "./TeacherDetail.vue?vue&type=style&index=0&id=1f1373aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1373aa"]])

export default __exports__